<template>
  <div class="micSetting flexcenter">
    <transition>
      <div class="setting flexcenter">
        <div class="settingInner">
        <!-- タイトル -->
        <h3 class="lbold font22">設定</h3>

        <div class="settingContent">
          <div class="settingContentInner">
          <div class="flexstart config-mic">
            <div class="settingtitle">音声認識</div>
            <div class="config">
              <div class="flexbetween">
                <div class="flexrow">
                  <div class="item"><input type="radio" id="sreUseTrue" value="true" v-model="sreUse" :disabled="locked"><label for="sreUseTrue">有効</label></div>
                  <div class="item"><input type="radio" id="sreUseFlase" value="false" v-model="sreUse" :disabled="locked"><label for="sreUseFlase">無効</label></div>
                </div>
                <span v-if="isDocomo" class="configtitle font10">有線のイヤホンマイク/ヘッドセットのご使用をされない場合、周囲の音や音声を拾って設問が進行することがあります。</span>
                <button v-if="!isMobile" type="button" :disabled="sreUse === 'false' || locked" @click="settingMicrophone"><span>マイク設定</span></button>
              </div>
            </div>
          </div>

          <div class="flexstart config-quality">
            <div class="settingtitle">音質</div>
            <div class="config flexstart">
              <div v-for="(gender, index) in genders" :key="index">
                <button :class="{
                    male:gender.value=='male',
                    female:gender.value=='female',
                    child:gender.value=='child',
                    active:gender.selected && sreUse === 'true'
                  }" type="button" :disabled="sreUse === 'false' || locked" @click="selectGender(index)"><span>{{ gender.label }}</span></button>
              </div>
            </div>
          </div>

          <div class="flexstart config-pronunce">
            <div class="settingtitle">発音設定</div>
            <div class="config" :class="sreUse">
              <div :class="{ configtitle:true, font10:isDocomo, font13:!isDocomo }">(会話のアクティビティで目標とするスコアを設定してください)</div>
              <input id="range-pronunce" type="range" :disabled="sreUse === 'false' || locked" min="0" max="10" list="number" v-model="difficulty" />
              <div id="pronunce-datalist">
                <div class="pronunce-scale">
                  <span class="level0"></span>
                  <span class="level1"></span>
                  <span class="level2"></span>
                  <span class="level3"></span>
                  <span class="level4"></span>
                  <span class="level5"></span>
                  <span class="level6"></span>
                  <span class="level7"></span>
                  <span class="level8"></span>
                  <span class="level9"></span>
                  <span class="level10"></span>
                </div>
                <div class="pronunce-label">
                  <span class="level0">易しい</span>
                  <span></span>
                  <span></span>
                  <span class="level3">普通</span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span class="level10">難しい</span>
                </div>
              </div>
            </div>
            </div>
          </div>

          <div class="flexstart config-sound">
            <div class="settingtitle">解答時の音</div>
            <div class="config flexrow">
              <div class="item">
                <input type="radio" id="answerSoundTrue" value="true" v-model="answerSound" :disabled="locked"><label for="answerSoundTrue">有効</label>
              </div>
              <div class="item">
                <input type="radio" id="answerSoundFlase" value="false" v-model="answerSound" :disabled="locked"><label for="answerSoundFlase">無効</label>
              </div>
            </div>
          </div>
          
          <div v-if="isMobile" class="flexstart config-textSize">
            <div class="settingtitle">文字サイズ</div>
            <div class="config flexrow">
              <div class="item">
                <input type="radio" id="textSizeLarge" name="textSizeSetting" :value="textSizeList[0]" v-model="selectedTextSize" :disabled="locked"><label for="textSizeLarge">大きい</label>
              </div>
              <div class="item">
                <input type="radio" id="textSizeMiddle" name="textSizeSetting" :value="textSizeList[1]" v-model="selectedTextSize" :disabled="locked"><label for="textSizeMiddle">標準</label>
              </div>
              <div class="item">
                <input type="radio" id="textSizeSmall" name="textSizeSetting" :value="textSizeList[2]" v-model="selectedTextSize" :disabled="locked"><label for="textSizeSmall">小さい</label>
              </div>
            </div>
          </div>
          
          <!-- ポップアップ辞書機能クローズのため設定項目をコメントアウト -->
          <!--
            <div v-if="!isMobile" class="flexstart config-sound">
              <div class="settingtitle">ポップアップ辞書</div>
              <div class="config flexrow">
                <div class="item">
                  <input type="radio" id="popupDictionaryTrue" name="popupDictionaryUseRadio" value="true" v-model="popupDictionaryUse" :disabled="locked"><label for="popupDictionaryTrue">有効</label>
                </div>
                <div class="item">
                  <input type="radio" id="popupDictionaryFalse" neme="popupDictionaryUseRadio" value="false" v-model="popupDictionaryUse" :disabled="locked"><label for="popupDictionaryFalse">無効</label>
                </div>
              </div>
            </div>
          -->
          
        </div>

        <!-- ボタン -->
        <div class="buttons flexcenter">
          <button class="cancel" type="button" @click="close" :disabled="locked"><span>キャンセル</span></button>
          <button class="apply" type="button" @click="applySettings" :disabled="locked"><span>適用</span></button>
        </div>
      </div>
      </div>
    </transition>
  </div>
</template>

<script>
import common from "@/mixin/common";
import http from "@/mixin/http";
import * as constants from "@/mixin/constants";
import * as storeConstants from "@/store/constants";

const platform = require("platform");

export default {
  name: "setting",
  mixins: [
    common,
    http
  ],
  props: {
    isDocomo: Boolean
  },
  data: function() {
    return {
      sreUse: this.$store.getters.sreUse,
      selectedGender: this.$store.getters.gender,
      difficulty: this.$store.getters.difficulty,
      answerSound: this.$store.getters.answerSound,
      genders: [
        { value: "male", label: "男性", selected: false },
        { value: "female", label: "女性", selected: false },
        { value: "child", label: "子供(高声用)", selected: false }
      ],
      autoScreenTransition: this.$store.getters.autoScreenTransition,
      textSizeList: storeConstants.TEXT_SIZE_SETTING_LIST,
      selectedTextSize: this.$store.getters.textSize,
      locked: false,
      isMobile: !this.isEnvironmentPc(),
      popupDictionaryUse: this.$store.getters.popupDictionaryUse
    };
  },
  methods: {
    /**
     * 性別を選択
     *
     * @param {Number} selectedIndex 選択した性別のインデックス
     */
    selectGender: function(selectedIndex) {
      for (let i = 0; i < this.genders.length; i++) {
        let gender = this.genders[i];
        gender.selected = i == selectedIndex;
        if (gender.selected) {
          this.selectedGender = gender.value;
        }
      }
    },
    /**
     * マイク設定
     */
    settingMicrophone: function() {
      // SpeechEngine初期化済みか確認
      if (sonic_wrapper.isSreInitialized()) {
        this.$emit("showMicrophoneSelect", false);
      } else {
        // SpeechEngine初期化
        this.initEngine(false);
      }
    },
    /**
     * 設定適用処理
     */
    applySettings: function() {
      const self = this;
      self.log("Setting start applySettings");
      if (self.sreUse == "true") {
        // SpeechEngine初期化済みか確認
        if (sonic_wrapper.isSreInitialized()) {
          // 言語モデルロード
          self.loadSpeechModel();
        } else {
          // SpeechEngine初期化
          self.initEngine(true);
        }
      } else {
        // 設定更新
        self.updateSettings();
      }
    },
    /**
     * SpeechEngine初期化処理
     *
     * @param {Boolean} applied 適用処理時：true, 適用処理時以外：false
     */
    initEngine: function(applied) {
      const self = this;

      self.locked = true;

      let gender = applied ? self.selectedGender : this.$store.getters.gender;
      let difficulty = applied ? Number(self.difficulty) : Number(this.$store.getters.difficulty);
      // SREログ出力要否(本番環境ビルドの場合はログ出力無し)
      let needsLog = process.env.DEPLOY_ENV !== "production";
      // Flash版実行強制フラグ
      let forceFlash = this.isForceFlash();

      // 初期化処理
      this.log("Sonic SRE Load needsLog: " + needsLog + ", forceFlash: " + forceFlash);
      sonic_wrapper.initEngine("en-US", gender, difficulty, needsLog, forceFlash).then(function() {
        self.log("Sonic SRE Initialized.");
        self.outputLogSonicSettings();

        if (applied) {
          // 設定更新
          self.updateSettings();
        } else {
          // マイク設定画面表示
          self.$emit("showMicrophoneSelect", applied);
        }
      }).catch(function(message) {
        // エラー処理
        self.log(message);
        self.showSreError();
        self.sreUse = "false";
      }).then(function() {
        self.locked = false;
      });
    },
    /**
     * 言語モデルロード
     */
    loadSpeechModel: function() {
      const self = this;

      self.locked = true;

      let gender = self.selectedGender;
      let difficulty = Number(self.difficulty);

      // 言語モデルロード
      // LoadModelSessionで、successイベントが発火せず、endイベントが2回発火する現象に対応するため、以下の様に実装
      // errorイベントは発火するようなので、errorイベントが発火せずにendイベントが発火した際はセッション成功とする
      // endイベントは1度しか発火しないはずなので、フラグでendイベントが発火済みかを管理する
      let state = true;
      let isFinished = false;
      const callbacks = {
        error: function() {
          state = false;
        },
        end: function() {
          if (!isFinished) {
            isFinished = true;
            if (state) {
              self.outputLogSonicSettings();
              // 設定更新
              self.updateSettings();
            } else {
              // エラー処理
              self.log(sonic_wrapper.getErrorMessage());
              self.showSreError();
              self.sreUse = "false";
            }
            self.locked = false;
          }
        }
      };
      sonic_wrapper.loadSpeechModel("en-US", gender, difficulty, callbacks);
    },
    /**
     * SREエラー表示
     */
    showSreError: function() {
      // Flash無効時
      if (this.isForceFlash() && !swfobject.hasFlashPlayerVersion("1")) {
        this.$emit("showFlashHelp");
      } else {
        this.$emit("showError", constants.ERR_SRE, constants.ERROR_BUTTON_KIND_CLOSE);
      }
    },
    /**
     * 設定更新
     */
    updateSettings: function() {
      const self = this;
      // ストア設定値更新
      self.updateStore();
      // key-value設定API実行
      self.doSetKeyValue().then(async function(result) {
        if (self.sreUse == "true" && result && (await self.needsMicrophoneSetting(sonic_wrapper.getMicrophone()))) {
          // 要マイク設定
          self.$emit("showMicrophoneSelect", true);
        } else {
          self.$emit("close");
        }
      }).catch(function(message) {
        self.$emit("showError", message, constants.ERROR_BUTTON_KIND_LOGIN);
      });
    },
    /**
     * key-value設定APIを実行
     *
     * @return {Promise} resolve:処理成功(true)/処理失敗(false), reject:アクセスキー無効メッセージ
     */
    doSetKeyValue: function() {
      const self = this;
      // key-value設定API
      return new Promise(function(resolve, reject) {
        self.setKeyValue(self.$parent.productInfo.code, self.getApiParam()).then(function(response) {
          switch (response.result_code) {
            case "OK":
              resolve(true);
              break;
            case "INFO_INVALID_ACCESSKEY":
              let message = response.result_code;
              reject(message);
              break;
            default:
              resolve(false);
              break;
          }
        }).catch(function(err) {
          resolve(false);
        });
      });
    },
    /**
     * key-value設定APIパラメータ取得
     *
     * @return {String} key-value設定APIパラメータ：datajson文字列
     */
    getApiParam: function() {
      let result = { data: [] };
      result.data.push(this.getApiParamKeyValue(constants.DATA_SETTING_SRE_USE, this.sreUse));
      if (this.sreUse == "true") {
        result.data.push(this.getApiParamKeyValue(constants.DATA_SETTING_GENDER, this.selectedGender));
        result.data.push(this.getApiParamKeyValue(constants.DATA_SETTING_DIFFICULTY, this.difficulty));
      }
      result.data.push(this.getApiParamKeyValue(constants.DATA_SETTING_ANSWER_SOUND, this.answerSound));
      result.data.push(this.getApiParamKeyValue(constants.DATA_SETTING_AUTO_SCREEN_TRANSITION, this.autoScreenTransition));
      result.data.push(this.getApiParamKeyValue(constants.DATA_SETTING_TEXT_SIZE, this.selectedTextSize));
      result.data.push(this.getApiParamKeyValue(constants.DATA_SETTING_POPUP_DICTIONARY_USE, this.popupDictionaryUse));

      return JSON.stringify(result);
    },
    /**
     * key-value設定APIパラメータ取得
     *
     * @param {String} key キー名
     * @param {String} value 設定値
     * @return {Object} key-valueオブジェクト
     */
    getApiParamKeyValue: function(key, value) {
      let result = {};
      result[key] = value;
      return result;
    },
    /**
     * ストア設定値更新
     */
    updateStore: function() {
      this.$store.dispatch("setSreUse", this.sreUse);
      if (this.sreUse == "true") {
        this.$store.dispatch("setGender", this.selectedGender);
        this.$store.dispatch("setDifficulty", this.difficulty);
      }
      this.$store.dispatch("setAnswerSound", this.answerSound);
      this.$store.dispatch("setAutoScreenTransition", this.autoScreenTransition);
      this.$store.dispatch("setTextSize", this.selectedTextSize);
      this.$store.dispatch("setPopupDictionaryUse", this.popupDictionaryUse);
    },
    /**
     * 本画面を閉じる
     */
    close: function() {
      if (this.locked) {
        return;
      }
      this.$emit("close");
    }
  },
  created: function() {
    this.log("Setting start created");
    // 性別ボタン設定
    for (let gender of this.genders) {
      gender.selected = gender.value == this.selectedGender;
    }
  },
  mounted: function() {
    this.log("Setting start mounted");
    this.setBodyStylePosition(true);
  },
  beforeDestroy: function() {
    this.setBodyStylePosition(false);
  }
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// Setting.vue?e08064b2